import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take, timeout } from 'rxjs/operators';
import { selectProfileLoaded, selectUserProfile } from '@/store/current-user/current-user.selectors';

/** Upper bound on the wait, so a profile load that never settles cannot hang navigation. */
const PROFILE_WAIT_MS = 15000;

/**
 * Emits the current user's profile (or null) once, AFTER the profile load has
 * settled. Role guards must use this instead of reading `selectUserProfile`
 * directly: the initial navigation runs in parallel with the app initializer's
 * `/users/me` call, so on a refresh or deep link the store can still be empty
 * when a guard runs — which used to bounce real admins to the guards' deny path.
 */
export const waitForUserProfile = (store: Store): Observable<any | null> =>
  store.select(selectProfileLoaded).pipe(
    filter((loaded) => loaded),
    take(1),
    timeout({ first: PROFILE_WAIT_MS, with: () => of(true) }),
    switchMap(() => store.select(selectUserProfile).pipe(take(1))),
  );
